<template>
    <div v-if="showing !== null" style="position: relative;" id="buyTicketsComponent">
        <div v-show="mode===Modes.chooseSeats">
            <h1 :class="{currentStep: currentStep === Steps.nTickets}"><span>Step 1:</span> How many tickets?</h1>

            <div style="display: flex; gap: 0 10px; flex-wrap: wrap;">
                <b>Number of tickets</b>
                <div class="costs">
                    <div v-for="(cost, iCost) in showing.costs">
                        <span
                            v-if="showing.costs.length > 1"
                            class="cost-label"
                            v-text="cost.title"
                        />
                        <input
                            v-model="nTickets[iCost].seats"
                            class="nTickets"
                            type="text"
                            inputmode="numeric"
                            pattern="[0-9]*"
                            style="display: inline-block; width: 3em;"
                            :data-cy="'nTickets[' + iCost + ']'"
                        >
                        <span
                            v-text="'@ $' + (Number(cost.cost) + Number(showing.surcharge)).toFixed(2) + ' each'"
                        />
                    </div>
                </div>
                <img src="/img/arrow-left.svg" class="arrow" v-show="currentStep === Steps.nTickets">
                <p
                    class="help is-danger"
                    v-show="nTicketsErrorMessage"
                    v-text="nTicketsErrorMessage"
                    style="margin-top: 5px; flex: 0 0 100%;"
                />
                <p
                    class="help is-info"
                    v-html="nTicketsAvailableMessage"
                    style="flex: 0 0 100%; margin-top: 5px;"
                />
            </div>

            <h1 :class="{currentStep: currentStep === Steps.chooseSeats}" style="display: flex; line-height: 1;">
                Step 2:
                <span style="display: inline-block; margin-left: 0.5em;">
                    Choose your seats
                    <img src="/img/arrow-left.svg" class="arrow-down" v-show="currentStep === Steps.chooseSeats">
                    <br>
                    <span style="font-size: 70%;">and then click "Continue"</span>
                </span>
            </h1>
            <choose-seats-component
                :showing_hashid="showing.hashid"
                :n-tickets="nTicketsComputed"
                :show-buttons="false"
                ref="chooseSeatsComponent"
                @change="handleSeatChoiceChange"
                :data-showing-hashid="showing.hashid"
            />
<!--
            @chosen="seatGroupsChosen"
            @cancel="doClose"
-->
            <div class="actions">
                <button
                    @click.prevent="doClose"
                    style="float: left;"
                    v-text="'Cancel'"
                    class="cancel"
                />
                <img src="/img/arrow-left.svg" class="arrow-right" v-show="currentStep === Steps.continue">
                <button
                    :disabled="!seatChoice.valid"
                    @click.prevent="seatGroupsChosen"
                    v-text="'Continue'"
                    class="continue"
                    data-cy="continue"
                />
            </div>

        </div>
        <div v-show="mode===Modes.purchase">
            <h1>Buy tickets</h1>
            <ul class="buyTicketsShowing">
                <li><span class="label">Movie:</span> <span class="value"><i>{{showing.movie.title}}</i></span></li>
                <li><span class="label">Date:</span> <span class="value">{{ showing.shown_at.tz('America/New_York').format('dddd, MMMM D, YYYY')}}</span></li>
                <li><span class="label">Time:</span> <span class="value">{{ showing.shown_at.tz('America/New_York').format('h:mm a')}}</span></li>
            </ul>
            <div class="field is-horizontal">
                <div class="field-label" />
                <div class="field" style="font-style: italic;">
                    All fields are required.
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label" for="name">Name</label>
                </div>
                <div class="field">
                    <input
                        id="name"
                        name="name"
                        type="text"
                        v-model.lazy="$v.name.$model"
                        ref="focusFirst"
                    >
                    <p
                            class="help is-danger"
                            v-show="!$v.name.$pending && $v.name.$dirty && !$v.name.required"
                            id="error-name-required"
                            v-cloak
                    >
                        Name is required.
                    </p>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label" for="email">Email</label>
                </div>
                <div class="field">
                    <input
                            id="email"
                            name="email"
                            type="email"
                            inputmode="email"
                            v-model.lazy="$v.email.$model"
                    >
                    <p
                            class="help is-danger"
                            v-show="!$v.email.$pending && $v.email.$dirty && (!$v.email.required || !$v.email.email)"
                            id="error-email-email"
                            v-cloak
                    >
                        Provide a valid email address.
                    </p>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label" for="phone">Cell phone</label>
                </div>
                <div class="field">
                    <input
                            id="phone"
                            name="phone"
                            type="phone"
                            inputmode="tel"
                            v-model.lazy="$v.phone.$model"
                    >
                    <p
                            class="help is-danger"
                            v-show="!$v.phone.$pending && $v.phone.$dirty && !$v.phone.required"
                            id="error-phone-required"
                            v-cloak
                    >
                        Phone number is required.
                    </p>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label" for="nTickets">Tickets</label>
                </div>
                <div class="field">
                    <div class="costs">
                        <div v-for="(cost, iCost) in showing.costs">
                            <span
                                v-if="showing.costs.length > 1"
                                class="cost-label"
                                style="margin-left: 0;"
                                v-text="cost.title + ': '"
                            />
                            <span
                                v-text="nTickets[iCost].seats"
                            />
                        </div>
                    </div>
                    <span
                        v-if="!isOpenSeating"
                        @click="mode=Modes.chooseSeats"
                        style="font-size: 90%; cursor: pointer;"
                        class="help is-info"
                    >
                        Change or review seat selection
                    </span>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <div class="label">Terms</div>
                </div>
                <div class="field" style="width: 12em; text-align: right;">
                    <div>
                        <button
                            v-on:click="showTerms"
                            style="margin-bottom: 5px;"
                            data-cy="showTerms"
                            v-text="'Show terms'"
                        />
                    </div>
                    <p
                        class="help is-info"
                        v-show="promptToViewTerms"
                    >
                        Read the terms first ^^^
                    </p>
                    <label for="agreement" style="margin-right: 10px; font-size: 95%;">I agree to the terms</label>
                    <input
                        type="checkbox"
                        id="agreement"
                        v-model.lazy="$v.agreement.$model"
                        v-on:click="handleAgreeClick"
                        v-bind:class="{disabled: !viewedTerms}"
                        ref="agreeTerms"
                    >
                    <p
                        class="help is-danger"
                        v-show="$v.agreement.dirty && !$v.agreement.checked"
                        v-cloak
                    >
                        You must agree to the terms and conditions.
                    </p>
                </div>
            </div>

            <div class="field is-horizontal">
                <div class="field-label">
                    <div class="label">Total cost</div>
                </div>
                <div class="field">
                    <span>{{ totalCost | currency }}</span>
                </div>
            </div>

            <payment-form-component
                v-bind:amount="totalCost"
                v-bind:okToPay="okToPay"
                v-on:gotToken="buyTickets"
            ></payment-form-component>

            <div class="field is-horizontal" style="margin-top: 30px;">
                <div class="field-label">
                </div>
                <div class="field">
                    <button
                        v-on:click="doClose"
                        class="doClose"
                        ref="focusLast"
                    >Cancel
                    </button>
                </div>
            </div>
        </div>
        <div v-show="mode===Modes.viewTerms">
            <h1>Terms and conditions</h1>
            <div
                v-html="terms"
                class="terms"
            ></div>
            <div class="field is-horizontal" style="margin-top: 40px;">
                <div class="field-label">
                </div>
                <div class="field">
                    <button
                        v-on:click="closeTerms"
                        class="readTerms closeTerms"
                        ref="closeTermsButton"
                    >Close</button>
                    <button
                        v-on:click="agreeTerms"
                        class="readTerms agreeTerms"
                        ref="agreeTermsButton"
                        data-cy="agreeTermsButton"
                    >I agree!</button>
                </div>
            </div>
        </div>
        <div v-show="mode===Modes.processing" id="buyTicketsProcessing">
            <div>Processing...</div>
        </div>
        <div v-if="mode===Modes.confirm">
            <h1 data-cy="result-heading" data-status="success">Confirmation</h1>
            <ul style="list-style-type: none;">
                <li>Date of sale: {{ formatTimestamp(charge.timestamp) }}</li>
                <li>Amount authorized: ${{ charge.amount.toFixed(2) }}</li>
                <li>Last 4 of credit card: {{ charge.last4 }}</li>
                <li>&nbsp;</li>
                <li>Film: {{ showing.movie.title }}</li>
                <li>Showing:
                    {{ showing.shown_at.format('dddd, MMMM D, YYYY')}}
                    at
                    {{ showing.shown_at.format('h:mm a')}}
                </li>
                <li>Number of tickets: {{ nTicketsComputed }}<br></li>
                <li>Theater: {{ showing.seating_pattern.screen.name }}</li>
                <li
                    v-if="seatGroups.length === 1"
                >
                    Seat: {{ seatGroupsCommaList }}
                </li>
                <li
                    v-if="seatGroups.length > 1"
                >
                    Seats: {{ seatGroupsCommaList }}
                </li>
            </ul>
            <figure style="display: inline-block; margin: 30px 0;">
                <img
                        v-bind:src="'data:image/png;base64,' + (voucher && voucher.barcode && voucher.barcode.data)"
                >
                <figcaption style="text-align: center; font-family: sans-serif; font-size: 30px;">
                    {{ voucher && voucher.id }}
                </figcaption>
            </figure>
            <p>
                Bring this QR code to the box office to get your tickets.<br>We will also send an email with this information and QR code.
            </p>
        </div>
        <div v-show="mode===Modes.error">
            <h1 data-cy="result-heading" data-status="error">Error</h1>
            <p data-cy="error-message">
                {{ errorMessage }}
            </p>
            <button
                style="margin-top: 30px; float: right; padding: 7px;"
                v-on:click="mode = goBackTarget || Modes.purchase"
                ref="errorGoBack"
                data-cy="go-back-button"
                v-text="'Go back'"
            />
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    // vue2-filters to show cost formatted as currency
    import Vue2Filters from 'vue2-filters';

    Vue.use(Vue2Filters);

    import {validationMixin} from 'vuelidate';
    import {required, email, minValue, requiredUnless} from 'vuelidate/lib/validators';

    import PaymentFormComponent from '../_components/PaymentFormComponent.vue';
    import axios from 'axios';
    import * as dayjs from 'dayjs';
    import utc from 'dayjs/plugin/utc';
    import ChooseSeatsComponent from '../../_components/ChooseSeatsComponent';

    const checked = value => value;

    export default {
        components: {ChooseSeatsComponent, PaymentFormComponent},
        mixins: [
            Vue2Filters.mixin,
            validationMixin,
        ],
        props: {
            showing: Object,
            terms: String,
        },
        data() {
            return {
                seatsAvailable: null,
                seatsMax: null,
                name: '',
                email: '',
                phone: '',
                nTickets: [],
                seatGroups: [],
                seatGroupLabels: [],
                agreement: false,
                viewedTerms: false,
                promptToViewTerms: false,
                stripeToken: null,
                voucher: null,
                charge: null,
                mode: null,
                errorMessage: '',
                goBackTarget: null,
                // step: null,
                seatChoice: {
                    valid: false,
                    hashids: [],
                    labels: [],
                },
            }
        },
        validations() {
            return {
                name: {required},
                email: {
                    email,
                    // required: requiredUnless(function (vue) {
                    //     return vue.phone !== '';
                    // }),
                    required,
                },
                phone: {
                    // required: requiredUnless(function (vue) {
                    //     return vue.email !== '';
                    // }),
                    required,
                },
                nTickets: {
                    $each: {
                        seats: {},
                    },
                },
                agreement: {required, checked},
            };
        },
        computed: {
            seatGroupsCommaList() {
                // return this.seatGroups.map(sg => sg.label).join(', ');
                // return this.showing.seating_pattern.seat_groups
                //     .filter(sg => this.seatGroups.includes(sg.hashid))
                //     .map(sg => sg.label)
                //     .join(', ')
                // ;
                return this.seatGroupLabels.join(', ');
            },
            totalCost() {
                // return this.nTickets * (Number(this.showing.cost) + Number(this.showing.surcharge));
                return this.nTickets.reduce((totalCost, nTickets, iNTickets) => {
                    return totalCost + (Number(this.showing.costs[iNTickets].cost) + Number(this.showing.surcharge)) * (nTickets.seats ?? 0);
                }, 0);
            },
            okToPay() {
                return !this.$v.$invalid;
            },
            isOpenSeating() {
                return this.showing.seating_pattern.screen_hashid === '3ZR1M';
            },
            nTicketsComputed() {
                let totalTickets =  this.nTickets.reduce((sum, nTickets) => {
                    return sum + Number(nTickets.seats ?? 0);
                }, 0);

                if ( (totalTickets > this.seatsAvailable) || totalTickets < 1) {
                    return null;
                }

                return totalTickets;
            },
            nTicketsErrorMessage() {
                if (this.nTicketsComputed === null) {
                    return;
                }
                if (this.nTicketsComputed < 1) {
                    return 'Set valid number of tickets.';
                }
                if (this.seatsAvailable === null) {
                    return;
                }
                if (this.seatsAvailable < 1) {
                    return 'Show is sold out.';
                }
                if (this.nTicketsComputed > this.seatsAvailable) {
                    return 'Only ' + this.seatsAvailable + ' seat' + (this.seatsAvailable > 1 ? 's' : '') + ' available.';
                }
                return null;
            },
            nTicketsAvailableMessage() {
                if (this.seatsMax === null || this.seatsAvailable === null) {
                    return '';
                }
                return `We are limiting this screening to ${this.seatsMax} customers.<br>`
                    + `There are currently ${this.seatsAvailable} tickets available.`;
            },
            currentStep() {
                if ( (this.nTicketsComputed === null) || (!!this.nTicketsErrorMessage) ) {
                    return this.Steps.nTickets;
                }
                if (this.seatChoice.valid) {
                    return this.Steps.continue;
                }
                return this.Steps.chooseSeats;
            },
        },
        watch: {
            showing(cur) {
                if (!cur) {
                    return;
                }
                this.mode = this.isOpenSeating ? this.Modes.purchase : this.Modes.chooseSeats;
                let vue = this;
                // axios.get('/api/showings/' + this.showing.hashid + '/seats-available')
                //     .then(response => {
                //         vue.seatsAvailable = response.data.seatsAvailable;
                //     })
                // ;
                axios.get('/api/showings/' + this.showing.hashid + '/seat-stats')
                    .then(response => {
                        vue.seatsAvailable = response.data.seatsAvailable;
                        vue.seatsMax = response.data.seatsMax;
                    })
                ;
                this.nTickets.splice(0, this.nTickets.length, ...this.showing.costs.map(cost => {
                    return {
                        cost_id: cost.id,
                        seats: null,
                    };
                }));
                this.clearSeatChoices();
            }
        },

        methods: {
            clearSeatChoices() {
                this.seatChoice.valid = false;
                this.seatChoice.hashids.splice(0, this.seatChoice.hashids.length);
                this.seatChoice.labels.splice(0, this.seatChoice.labels.length);
            },
            handleSeatChoiceChange(valid, hashids, labels) {
                this.seatChoice.valid = !!valid;
                hashids = this.seatChoice.valid ? hashids : [];
                labels = this.seatChoice.valid ? labels : [];
                this.seatGroups.splice(0, this.seatGroups.length, ...hashids);
                this.seatGroupLabels.splice(0, this.seatGroupLabels.length, ...labels);
            },
            // seatGroupsChosen(hashids, labels) {
            seatGroupsChosen() {
                // this.nTickets = details.nTickets;
                // this.seatGroups = details.seatGroups;
                // this.seatGroups.splice(0, this.seatGroups.length, ...hashids);
                // this.seatGroupLabels.splice(0, this.seatGroupLabels.length, ...labels);
                if (this.stripeToken) {
                    this.buyTickets(null);
                } else {
                    this.mode = this.Modes.purchase;
                }

            },
            handleAgreeClick: function(evt) {
                if (!this.viewedTerms) {
                    this.promptToViewTerms = true;
                    evt.preventDefault();
                }
            },
            showTerms() {
                this.mode = this.Modes.viewTerms;
                this.promptToViewTerms = false;
                this.viewedTerms = true;
                document.querySelector('#buyTickets .modal-close').classList.add('hidden');
                this.$nextTick(() => this.$refs.agreeTermsButton.focus());
            },
            agreeTerms() {
                document.querySelector('#buyTickets .modal-close').classList.remove('hidden');
                this.mode = this.Modes.purchase;
                this.agreement = true;
            },
            closeTerms() {
                document.querySelector('#buyTickets .modal-close').classList.remove('hidden');
                this.mode = this.Modes.purchase;
                this.$nextTick(() => this.$refs.agreeTerms.focus());
            },
            showEmailPhoneError() {
                let emailError = !this.$v.email.$pending && this.$v.email.$dirty && !this.$v.email.required;
                let phoneError = !this.$v.phone.$pending && this.$v.phone.$dirty && !this.$v.phone.required;

                return emailError || phoneError;
            },
            buyTickets: function (stripeToken) {
                let vue = this;

                this.goBackTarget = null;
                this.stripeToken = stripeToken || this.stripeToken;
                this.mode = this.Modes.processing;

                axios.post('/api/buy-tickets', {
                    showing_id: vue.showing.hashid,
                    token: this.stripeToken,
                    name: vue.name,
                    email: vue.email,
                    phone: vue.phone,
                    costSeats: vue.nTickets,
                    // seatGroups: vue.seatGroups.map(sg => sg.hashid),
                    seatGroups: vue.seatGroups,
                })
                    .then(function (response) {
                        // axios.post('/api/logs', {message: 'Used token to complete purchase'});
                        vue.stripeToken = null;
                        vue.voucher = response.data.voucher;
                        vue.charge = response.data.charge;
                        vue.mode = vue.Modes.confirm;
                    })
                    .catch(function (error) {
                        switch (error.response.status) {
                            case 402:
                                axios.post('/api/logs', {message: 'Problem using token to complete purchase: ' + error.response.data.message});
                                vue.stripeToken = null;
                                vue.goBackTarget = vue.Modes.purchase;
                                break;
                            case 409:
                                axios.post('/api/logs', {message: 'BuyTickets seat selection error.' });
                                vue.clearSeatChoices();
                                vue.$refs.chooseSeatsComponent.clearChosenSeatGroups();
                                vue.$refs.chooseSeatsComponent.loadShowing();
                                vue.goBackTarget = vue.Modes.chooseSeats;
                                break;
                            default:
                                // TODO clean up to a manageable state
                                axios.post('/api/logs', {message: 'BuyTickets error: ' + error.response.data.message});
                        }
                        vue.errorMessage = error.response.data.message;
                        vue.mode = vue.Modes.error;
                        vue.$nextTick(() => vue.$refs.errorGoBack.focus());
                    })
                ;
            },
            formatTimestamp: function(ts) {
                return dayjs.unix(ts).format('MMMM D, YYYY, h:mm a');
            },
            doClose() {
                this.mode = this.Modes.chooseSeats;
                this.$emit('close');
            },
            focusFirst() {
                this.$refs.focusFirst.focus();
            },
            moveFocusUp: function(evt) {
                if (evt.target === this.$refs.focusFirst) {
                    evt.preventDefault();
                    this.$refs.focusLast.focus();
                }
            },
            moveFocusDown: function(evt) {
                if (evt.target === this.$refs.focusLast) {
                    evt.preventDefault();
                    this.$refs.focusFirst.focus();
                }
            },
        },
        created() {
            this.Modes = {
                chooseSeats: 1,
                purchase: 2,
                viewTerms: 3,
                processing: 4,
                confirm: 5,
                error: 6,
            };
            this.mode = this.Modes.chooseSeats;

            this.Steps = {
                nTickets: 1,
                chooseSeats: 2,
                continue: 3,
            };
            // this.step = this.Steps.nTickets;
        },

    }
</script>

<style lang="scss">
#buyTicketsComponent {
    h1 {
        font-size: calc(min(6vw, 35px));
        margin: 0.2em 0;
        padding: 2px;
        border-radius: 5px;

        &.currentStep {
            background-color: #d88d34;
        }
    }

    .cost-label {
        display: inline-block;
        width: 4em;
        margin-left: 1em;
    }

    #agreement.disabled {
        cursor: not-allowed;
    }

    #buyTicketsProcessing {
        display: flex;
        justify-content: center;
        align-items: center;
        align-content: center;
    }

    #buyTicketsProcessing div {
        font-size: 20pt;
        font-weight: bold;
        color: #0E9A00;
    }
    .terms {
        ul {
            list-style: disc;
            margin-left: 20px;
        }
        li {
            margin-bottom: 10px;
        }
    }
    .readTerms {
        transition: background-color 0.3s ease-in-out;
        padding: 10px;
        width: 7.5em;

    }
    .agreeTerms {
        background-color: #e0a55f;
        color: #052036;

        &:hover {
            background-color: #d88d34;
        }
    }
    .closeTerms {
        background-color: #dddddd;

        &:hover {
            background-color: #999999;
        }
    }
    @keyframes pointLeft {
        from,
        to {
            transform: translate3d(0, 0, 0);
        }

        50% {
            transform: translate3d(-10px, 0, 0);
        }
    }
    .arrow {
        transform: none;
        animation-duration: 1.2s;
        animation-iteration-count: infinite;
        animation-name: pointLeft;
    }
    @keyframes pointRight {
        from,
        to {
            transform: translate3d(0, 0, 0) rotate(180deg);
        }

        50% {
            transform: translate3d(-10px, 0, 0) rotate(180deg);
        }
    }
    .arrow-right {
        transform: rotate(180deg);
        animation-duration: 1.2s;
        animation-iteration-count: infinite;
        animation-name: pointRight;
        height: 2em;
    }
    @keyframes pointDown {
        from,
        to {
            transform: translate3d(0, 0, 0) rotate(-90deg);
        }

        50% {
            transform: translate3d(0, 0.25em, 0) rotate(-90deg);
        }
    }
    .arrow-down {
        height: 1.5em;
        margin-bottom: -0.6em;
        transform: rotate(-90deg);
        animation-duration: 1.2s;
        animation-iteration-count: infinite;
        animation-name: pointDown;
    }

    .actions {
        display: flex;
        justify-content: right;

        button {
            padding: 5px;
            width: 7.5em;
            background-color: #e0a55f;
            color: #052036;

            &[disabled] {
                background-color: #ccc;
                color: #444;
            }

            &.cancel {
                font-size: 75%;
                background-color: #ebdaad;
                margin-right: auto;
            }
        }
    }

    .buyTicketsShowing {
        border: 2px solid #d88d34;
        border-radius: 5px;
        padding: 0 3px;
        margin-bottom: 10px;
        background-color: #ebdaad;

        .label, .value {
            display: inline-block;
            margin-bottom: 5px;
        }

        .label {
            width: 4em;
        }

        .value {
            font-weight: bold;
            color: #0c4464;
        }
    }
}
</style>
